export const queryLang = 'en_RU';
export const minZoom = 2;
export const zoom = 2;
export const capitalTranslation: Record<string, unknown> = {
  ru: 'Столица',
  en: 'Capital',
  bg: 'Капитал',
};
export const fillMethod = 'stretch';
export const fillOpacity = 0.6;
export const strokeColor = '#000';
export const strokeOpacity = 0.5;
export const fillColor = '#3D4C76';
export const customPreset = 'islands#redGovernmentIcon';
export const loadingModules = ['borders', 'Polygon', 'geoObject.addon.balloon'];
export const loadingGeometry = '001';
export const loadingLanguage = 'en';
export const loadingQuality = 3;
export const yaMapsApiKey = 'd5fce317-37f1-4ed2-aef6-b06cbd084bdf';
